var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvailableIco(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.310425,
    y: 0.544922,
    width: 56,
    height: 56,
    rx: 28,
    fill: "black",
    fillOpacity: 0.16
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_168_495)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.3104 41.0449C21.4177 41.0449 15.8104 35.4376 15.8104 28.5449C15.8104 21.6522 21.4177 16.0449 28.3104 16.0449C35.2031 16.0449 40.8104 21.6522 40.8104 28.5449C40.8104 35.4376 35.2031 41.0449 28.3104 41.0449ZM28.3104 19.1699C23.1417 19.1699 18.9354 23.3751 18.9354 28.5449C18.9354 33.7147 23.1417 37.9199 28.3104 37.9199C33.4792 37.9199 37.6854 33.7147 37.6854 28.5449C37.6854 23.3751 33.4802 19.1699 28.3104 19.1699ZM33.5188 29.0658C33.5188 28.2033 32.8188 27.5033 31.9563 27.5033H29.3521V22.8158C29.3521 21.9533 28.6531 21.2533 27.7896 21.2533C26.926 21.2533 26.2271 21.9533 26.2271 22.8158V29.0658C26.2271 29.9283 26.926 30.6283 27.7896 30.6283H31.9563C32.8188 30.6283 33.5188 29.9283 33.5188 29.0658Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_168_495"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "translate(15.8104 16.0449)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvailableIco);
export default __webpack_public_path__ + "static/media/availableIco.474aa7f2320ebcaed50016fa99134044.svg";
export { ForwardRef as ReactComponent };